import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [showError, setShowError] = useState(false);
  const { login, loading, error } = useAuth();

  const handleGoogleLogin = async () => {
    setShowError(false);
    const result = await login();
    
    if (!result.success) {
      setShowError(true);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Aerotubos2025</h1>
          <p>Product Management System</p>
        </div>
        
        <div className="login-form">
          {(showError || error) && (
            <div className="error-message">
              {error || 'Login failed. Please try again.'}
            </div>
          )}
          
          <button 
            onClick={handleGoogleLogin}
            className="google-login-button"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in with Google'}
          </button>
        </div>
        
        <div className="login-footer">
          <p>Sign in with your Google account to access the system</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
